import { initPage } from './init';
import './accessibility';
import './site-menu';
import './video';
import './notices';
import './dialog';
import './top-bar';
import './crumbs';
import './tabs';
import './jump-bar';
import './google-maps';
import './gallery';
import './filter';
import './search';
import './parallax';
import './count-up';
import './cards-scroller';

import inView from 'in-view';

import objectFitImages from 'object-fit-images';

objectFitImages();

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Initialize aria visibility toggles.
   *
   * Usage:
   *    <button aria-expanded="false" aria-controls="myDropdown">Toggle</button>
   *    <div id="myDropdown" aria-hidden="true">Dropdown</div>
   */
  document.querySelectorAll('[aria-controls][aria-expanded]').forEach((el) => {
    if (el.getAttribute('aria-autocomplete')) return;
    el.addEventListener('click', (e) => {
      const id = el.getAttribute('aria-controls');
      const controlled = document.getElementById(id);
      if (!controlled) return;
      const open = controlled.getAttribute('aria-hidden') !== 'false';

      controlled.setAttribute('aria-hidden', open ? 'false' : 'true');

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      e.preventDefault();

      if (open) {
        // Add document click listener to close dropdown when clicking elsewhere
        const closeDropdown = (event) => {
          if (
            !el.contains(event.target) &&
            !controlled.contains(event.target)
          ) {
            controlled.setAttribute('aria-hidden', 'true');
            document
              .querySelectorAll(`[aria-controls="${id}"]`)
              .forEach((btn) => {
                btn.setAttribute('aria-expanded', 'false');
              });
            document.removeEventListener('click', closeDropdown, true);
          }
        };
        setTimeout(() => {
          document.addEventListener('click', closeDropdown, true);
        }, 0);
      }
    });
  });

  /**
   * Scrolling
   */
  document.addEventListener('scroll', function (e) {
    if (window.scrollY > 0) {
      document.querySelector('#main').classList.add('is-scrolled-off-top');
    } else {
      document.querySelector('#main').classList.remove('is-scrolled-off-top');
    }
  });

  /**
   * Live preview detection
   */
  if (window.self !== window.top) {
    document.documentElement.classList.add('is-live-preview');
  }

  // -------------
  // In view
  // https://github.com/camwiegert/in-view
  // -------------
  inView.threshold(0.5); // 50% of element must be visible to trigger

  // adds 'visible' class once when it becomes visible
  inView('.iv-once').on('enter', (el) => {
    el.classList.add('visible');
  });

  inView('.iv-once-children > *').on('enter', (el) => {
    el.classList.add('visible');
  });

  // adds 'visible' class when it becomes visible, then removes class when it stops being visible
  inView('.iv-repeat')
    .on('enter', (el) => {
      el.classList.add('visible');
    })
    .on('exit', (el) => {
      el.classList.remove('visible');
    });

  inView('.iv-pop').on('enter', (el) => {
    el.classList.add('visible');
  });

  document.querySelectorAll('.iv-once').forEach((el) => {
    const rect = el.getBoundingClientRect();
    const inViewport =
      rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0;
    if (inViewport) {
      el.classList.add('visible');
    }
  });

  initPage();

  function scrollToHash() {
    if (!window.location.hash) return;

    const el = document.querySelector(window.location.hash);
    if (!el) return;

    // Instantly jump (no animation)
    el.scrollIntoView({
      behavior: 'auto',
      block: 'start',
    });
  }

  window.addEventListener('load', () => {
    scrollToHash();

    // Handles late layout shifts from images/forms/fonts/etc
    setTimeout(scrollToHash, 300);
  });
});
